import { Box, Button, Paper, Stack, TextField, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import PoweredBy from "@entrilia/shared/components/PoweredBy";
import type { PortalStyleSettings } from "./investorPortalStyleState";
import usePreviewTheme from "./usePreviewTheme";

interface Props {
  settings: PortalStyleSettings;
}

const SignInPagePreview = ({ settings }: Props) => {
  const previewTheme = usePreviewTheme(settings.primaryThemeColor);
  const showBackgroundImage = settings.useBackgroundImage && !!settings.backgroundImageUrl;

  return (
    <ThemeProvider theme={previewTheme}>
      <Stack
        inert
        sx={{
          height: "100%",
          borderRadius: 1,
          overflow: "hidden",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: settings.backgroundColor,
          backgroundImage: showBackgroundImage ? `url(${settings.backgroundImageUrl})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Paper sx={{ width: 400, p: 3 }}>
          <Stack spacing={2}>
            {settings.clientLogoUrl ? (
              <Box component="img" src={settings.clientLogoUrl} alt="" sx={{ height: 32, objectFit: "contain" }} />
            ) : (
              <Typography variant="h6" color="textDisabled" sx={{ textAlign: "center" }}>
                Logotype
              </Typography>
            )}
            <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
              Sign in
            </Typography>
            <TextField label="Email" defaultValue="john.doe@example.com" />
            <TextField label="Password" type="password" defaultValue="passwordvalue" />
            <Button variant="contained" fullWidth>
              Sign in
            </Button>
            <Typography variant="caption" sx={{ textAlign: "center" }}>
              Don&apos;t have an account?{" "}
              <Typography variant="caption" color="primary">
                Sign up
              </Typography>
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", whiteSpace: "nowrap" }}>
              <Stack direction="row" spacing={1.5}>
                <Typography variant="caption" color="primary">
                  Forgot password?
                </Typography>
                <Typography variant="caption">Need help?</Typography>
              </Stack>
              <PoweredBy />
            </Box>
          </Stack>
        </Paper>
      </Stack>
    </ThemeProvider>
  );
};

export default SignInPagePreview;
